import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
    },
    columns: {
      display: "flex",
    },
  });

export const useStyles = makeStyles(styles);
